import React from 'react';
import { getFAQPageSchema, IFAQSchema } from '../../../../helpers/schema';

export const FAQSchema = ({ faqMetaData }: { faqMetaData: IFAQSchema[] }) => {
  return (
    <script
      type="application/ld+json"
      // faqMetaData is already sanitized in getFAQPageSchema
      dangerouslySetInnerHTML={{ __html: getFAQPageSchema(faqMetaData) }}
    />
  );
};
